/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForTerraformTemplateExecution extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForTerraformTemplateExecution");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForTerraformTemplateExecution.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForTerraformTemplateExecution>): BackgroundJobPayloadForTerraformTemplateExecution {
        let obj = Object.assign(new BackgroundJobPayloadForTerraformTemplateExecution(), model);
        BackgroundJobPayloadForTerraformTemplateExecution.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForTerraformTemplateExecution>): BackgroundJobPayloadForTerraformTemplateExecution {
        if (!model) return null;
        return BackgroundJobPayloadForTerraformTemplateExecution.newInstance(<BackgroundJobPayloadForTerraformTemplateExecution> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForTerraformTemplateExecution) {
        if (!obj) return;

        models.BackgroundJobPayloadForTerraformTemplateExecution.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForTerraformTemplateExecution): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForTerraformTemplateExecution.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    job_id: string;

    notification_email_id: string;

    /**
     * parameters to template
     */
    execution_params: any;

}
